import type { Handler } from './handler';
import type {
  ApiFetchGiratudoLeaderboardPort,
  RaffleLeaderboardResponse,
} from './ports/api-fetch-giratudo-leaderboard.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchGiratudoLeaderboardHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchGiratudoLeaderboard: resolveAdapter('apiFetchGiratudoLeaderboard'),
  },
) => {
  const [leaderboard, error] = await tryCatch(
    ports.apiFetchGiratudoLeaderboard.handle(
      params.userId,
      params.page,
      params.perPage,
    ),
  );

  if (error) {
    console.error('Error fetching giratudo leaderboard:', error);

    return {
      data: [],
      currentPage: 1,
      totalPages: 0,
      userPosition: null,
    };
  }

  return leaderboard as RaffleLeaderboardResponse;
};

type Params = { userId?: number; page?: number; perPage?: number };

type Ports = { apiFetchGiratudoLeaderboard: ApiFetchGiratudoLeaderboardPort };

type Result = Promise<RaffleLeaderboardResponse>;
